import React, { useEffect, useState, useCallback } from 'react';
import { motion } from 'framer-motion';

const Card = (props) => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const handleMouseMove = useCallback((event) => {
    setMousePosition({ x: event.clientX, y: event.clientY });
  }, []);

  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [handleMouseMove]);

  // Normalize mouse position to [-0.5, 0.5]
  const x = mousePosition.x / window.innerWidth - 0.5; 
  const y = mousePosition.y / window.innerHeight - 0.5;

  return (
    <motion.div
      className={`hidden lg:flex flex-col gap-5 rounded-md shadow-xl absolute top-0 bottom-0 m-auto right-10 p-6 h-fit w-1/3 ${props.darkMode ? 'bg-neutral-900':' bg-white'}`}
      style={{
        translateX: `${x * 30}px`,
        translateY: `${y * 30}px`,
      }}
      initial={{ scale: 1, opacity: 0.9 }}
      whileHover={{ scale: 1.05, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
    >
      <h1 className={`text-4xl font-bold ${props.darkMode ? 'text-orange-500':'text-purple-800'}`}>Hi, I'm Arsal</h1>
      <p className={props.darkMode?'text-white': 'text-gray-400'}>
        Passionate developer and designer crafting seamless digital experiences. I specialize in building responsive
        websites and intuitive user interfaces with clean, modern aesthetics.
        My focus is on blending creativity with functionality to deliver high-performance
        solutions. Let’s bring your ideas to life with innovation and precision.
      </p>
      <div
        className={`text-white text-xl px-3 py-2 rounded-md font-semibold w-fit transition transform hover:scale-105 shadow-sm cursor-pointer ${props.darkMode ? 'bg-orange-600':'bg-purple-800'} `}
        onClick={() => handleScroll('contact')} // Adjusted to use arrow function
        tabIndex={0} // Makes the button focusable
        role="button" // Optional for accessibility
      >
        Hire Me
      </div>
    </motion.div>
  );
};

export default Card;
